import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import Chat from '@/components/features/chat/layout/Chat';
import ConversationsList from '@/components/features/chat/layout/ConversationsList';
import CreateChat from '@/components/features/manage/manage-chats/CreateChat';
import { useMediaQuery } from '@/hooks/media-query';
import { useChatStore } from '@/store/chat-store';

export default function ChatPage() {
  const [openCreate, setOpenCreate] = useState<boolean>(false);
  const breakpoint = useMediaQuery('lg');
  const resetToDefaults = useChatStore((state) => state.resetToDefaults);

  const params = useParams();
  const id = Number(params.id);

  useEffect(() => {
    return () => {
      resetToDefaults();
    };
  }, []);

  return (
    <div className={'base-direction-row viewport-height box-border min-h-0 overflow-y-auto p-0 md:overflow-y-hidden md:p-4'}>
      <CreateChat open={openCreate} onOpenChange={setOpenCreate} />
      {breakpoint && <ConversationsList openCreateConversation={() => setOpenCreate(true)} />}
      <Chat id={id} />
    </div>
  );
}
